import React, { useState, useEffect, useContext } from 'react'; 
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Common/Configurations/AuthContext';
import './PrivateHeader.css';
import { LandingContext } from '../../Components/Profile/LandingContext';
import DefaultData from '../../CompanyData/DefaultData';


const PrivateHeader = (props) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const navLinks = [
        { path: "/flight/search", icon: "ri-plane-line", label: "Flights" },
        { path: "/hotel/search", icon: "ri-building-4-line", label: "Hotels" },
        { path: "/holidays", icon: "ri-suitcase-2-line", label: "Packages" },
        { path: "/search/sightseeing", icon: "ri-camera-lens-line", label: "SightSeeing" },
        { path: "/bookingrequest", icon: "ri-group-line", label: "Group Bookings" }
    ];

    const logoSrc = props.value?.companyLogo || '/assets/images/logo.png';
    const landingData = useContext(LandingContext);
         const headerStyles = {
            '--theme-background': landingData?.themeColor3 || DefaultData?.THEMECOLOR3, // For the button
             '--theme-primary-action' : landingData?.themeColor1 || DefaultData?.THEMECOLOR2 , // For icons and highlights
            '--theme-secondary-accent': landingData?.themeColor2 || DefaultData?.THEMECOLOR1  // For icons and highlights
        };
    return (
          <header className="b2b-private-header" style={headerStyles}>
            <div className="container-fluid">
                <div className="navbar-content">
                    <div className="navbar-logo">
                        <Link to="/" className="logo-link">
                            <img src="/assets/images/logo.png" alt="Company Logo2" width={"160px"} height={"150px"} />
                        </Link>
                    </div>

                    <nav className="navbar-links">
                        {navLinks.map(link => (
                            <NavLink 
                                key={link.path}
                                to={link.path} 
                                className="nav-link-item"
                            >
                                <i className={link.icon}></i>
                                <span>{link.label}</span>
                            </NavLink>
                        ))}
                    </nav>

                    <div className="navbar-actions">
                        <div className="user-profile-menu">
                            <Link to="/my-profile" className="btn btn-my-account">
                                <i className="ri-user-settings-line"></i>
                                <span>Welcome, {user?.name || user?.email}</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default PrivateHeader;